"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
require("../tabs.css");
var _excluded = ["activeTab", "children", "className", "parentId"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A `TabPanelList` should be placed as an immediate descendant of a `Tabs` component, but _beneath_ a `TabList` component.
 *
 * It should surround `TabPanel` components.
 *
 * **Note that only the props listed below should be modified, as this component is controlled by `Tabs`.**
 */
var TabPanelList = function TabPanelList(_ref) {
  var activeTab = _ref.activeTab,
    children = _ref.children,
    className = _ref.className,
    parentId = _ref.parentId,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var childrenWithProps = _react["default"].Children.map(children, function (child, idx) {
    if (!child) return null;
    var index = child.props.index || idx;
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      tabId: index,
      parentId: parentId,
      isActive: activeTab === index
    });
  });
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: (0, _classnames["default"])('position-relative', _defineProperty({}, className, className))
  }, otherProps), childrenWithProps);
};
TabPanelList.displayName = 'TabPanelList';
TabPanelList.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Only `TabPanel` components should be passed in as children.
   */
  children: function children(props, propName, componentName) {
    var error;
    var prop = props[propName];
    _react["default"].Children.forEach(prop, function (child) {
      if (!child) return;
      if (child.type.displayName !== 'TabPanel') {
        error = new Error("`".concat(componentName, "` only accepts children of type `TabPanel`."));
      }
    });
    return error;
  },
  /**
   * This class is assigned to the surrounding container that wraps the child elements.
   */
  className: _propTypes["default"].string
} : {};
var _default = exports["default"] = TabPanelList;